import { useEffect } from 'react'

import { MARCO_BRAND } from '@/brand/marco'
import { useBrand } from '@/shared/providers/brand-provider'

import { useEntityBranding } from './entity-queries'

// Shows entityId's branding, or Marco's when there's no entity or its branding can't be read.
export function useEntityBrandSync(entityId: string | null): void {
  const { data, isError } = useEntityBranding(entityId)
  const { setBrand } = useBrand()

  useEffect(() => {
    if (entityId === null || isError) setBrand(MARCO_BRAND)
    else if (data !== undefined) setBrand(data ?? MARCO_BRAND)
  }, [entityId, data, isError, setBrand])
}
